import service from "@/store/services/type-mails-service";
import Jsona from "jsona";

const jsona = new Jsona();

export const state = () => ({
  list: {},
  typeMail: {},
  meta: {},
  url: null,
});

export const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, typeMail) => {
    state.typeMail = typeMail;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  },
  SET_URL: (state, url) => {
    state.url = url;
  },
};

export const actions = {
  list({ commit, dispatch }, params = {}) {
    return service.list(params, this.$axios).then(({ list, meta }) => {
      commit("SET_LIST", list);
      commit("SET_META", meta);
    });
  },

  get({ commit, dispatch }, params) {
    return service.get(params, this.$axios).then((typeMail) => {
      commit("SET_RESOURCE", typeMail);
    });
  },

  add({ commit, dispatch }, params) {
    return service.add(params, this.$axios).then((typeMail) => {
      commit("SET_RESOURCE", typeMail);
    });
  },

  update({ commit, dispatch }, params) {
    return service.update(params, this.$axios).then((typeMail) => {
      commit("SET_RESOURCE", typeMail);
    });
  },

  destroy({ commit, dispatch }, params) {
    return service.destroy(params, this.$axios);
  },
};

const getters = {
  list: (state) => state.list,
  listTotal: (state) => state.meta.page.total,
  typeMail: (state) => state.typeMail,
  url: (state) => state.url,
  dropdown: (state) => {
    return state.list.map((typeMail) => ({
      id: typeMail.id,
      label: typeMail.label,
    }));
  },
};

const typeMails = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default typeMails;
